import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
export var AvatarImage = _ref => {
  var {
    avatarImageSize,
    altText,
    source,
    imgStyle,
    hasSourceStyle,
    onError
  } = _ref;
  return /*#__PURE__*/React.createElement("img", {
    alt: altText,
    src: source,
    height: avatarImageSize,
    width: avatarImageSize,
    style: _objectSpread(_objectSpread({}, imgStyle), hasSourceStyle),
    onError: event => {
      onError && onError();
      // @ts-expect-error
      event.target.style.display = 'none';
    }
  });
};
//# sourceMappingURL=AvatarImage.js.map